
const {
    DEV,
    QA,
    CARD,
    STAGING,
    OCULTO,
    DEV_HOST,
    QA_HOST,
    STAGING_HOST,
    OCULTO_HOST,
    SPAIN,
    API_DETAIL_URL,
    DEVCC,
    QACC,
    STAGINGCC,
    OCUCC,
    PRODCC,
    PROD_HOST,
    PROD
  } = require('constants/index');

const getUrlAPINGOs = (host = STAGING_HOST, country = SPAIN, isContactCenter, context = CARD ) => {
    let urlAPI = '';
    const API_URL = '/my-cards/solidarity/ngos?solidarityCorner=true&solidarity' + context + '=true&country=';
    if (![DEV_HOST, QA_HOST, STAGING_HOST, OCULTO_HOST, PROD_HOST].includes(host)){
      return `${host}${API_URL}${country}`;
    }

    switch (host) {
      case DEV_HOST:
        urlAPI = `${isContactCenter ? DEVCC : DEV}${API_URL}${country}`;
        break;
      case QA_HOST:
        urlAPI = `${isContactCenter ? QACC : QA}${API_URL}${country}`;
        break;
      case STAGING_HOST:
        urlAPI = `${isContactCenter ? STAGINGCC : STAGING}${API_URL}${country}`;
        break;
      case OCULTO_HOST:
        urlAPI = `${isContactCenter ? OCUCC : OCULTO}${API_URL}${country}`;
        break;
      case PROD_HOST:
          urlAPI = `${isContactCenter ? PRODCC : PROD}${API_URL}${country}`;
        break;
      default:
        urlAPI = `${isContactCenter ? PRODCC : PROD}${API_URL}${country}`;
    }

    return urlAPI;
}

const getUrlAPINGODetail = (host = STAGING_HOST, country = SPAIN, idNgo, isContactCenter) => {
  let urlAPI = '';

  if (![DEV_HOST, QA_HOST, STAGING_HOST, OCULTO_HOST, PROD_HOST].includes(host)) {
    return `${host}${API_DETAIL_URL}${country}/solidario-${idNgo}/1`;
  }

  switch (host) {
    case DEV_HOST:
      urlAPI = `${isContactCenter ? DEVCC : DEV}${API_DETAIL_URL}${country}/solidario-${idNgo}/1`;
      break;
    case QA_HOST:
      urlAPI = `${isContactCenter ? QACC : QA}${API_DETAIL_URL}${country}/solidario-${idNgo}/1`;
      break;
    case STAGING_HOST:
      urlAPI = `${isContactCenter ? STAGING : STAGINGCC}${API_DETAIL_URL}${country}/solidario-${idNgo}/1`;
      break;
    case OCULTO_HOST:
      urlAPI = `${isContactCenter ? OCUCC : OCULTO}${API_DETAIL_URL}${country}/solidario-${idNgo}/1`;
      break;
    case PROD_HOST:
        urlAPI = `${isContactCenter ? PRODCC : PROD}${API_DETAIL_URL}${country}/solidario-${idNgo}/1`;
      break;
    default:
      urlAPI = `${isContactCenter ? PRODCC : PROD}${API_DETAIL_URL}${country}/solidario-${idNgo}/1`;
  }

  return urlAPI;
}

module.exports = {
  getUrlAPINGOs,
  getUrlAPINGODetail
}